import React from 'react';

import './Landing.css';
import ScrollButton from './ScrollButton';

import { withRouter } from 'react-router-dom';
import { Button, Grid } from '@material-ui/core';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import bg12 from '../../../assets/images/Cover-min.png';
import headersSection from './headersStyle';

// import components
import Definition from './landingComponents/Definition';
import Advantages from './landingComponents/Advantages';
import ServiceList from './landingComponents/ServiceList';
// import Importance from './landingComponents/Importance';
import Users from './landingComponents/Users';
import Roles from './landingComponents/Roles';
import Connecting from './landingComponents/Connecting';
import Spreading from './landingComponents/Spreading';
import Comments from './landingComponents/Comments';
// import LandingLinks from './landingComponents/LandingLinks';
import TeachingVideo from './landingComponents/TeachingVideo';

const hexToRgb = (input) => {
  input = input + '';
  input = input.replace('#', '');
  let hexRegex = /[0-9A-Fa-f]/g;
  if (!hexRegex.test(input) || (input.length !== 3 && input.length !== 6)) {
    throw new Error('input is not a valid hex color.');
  }
  if (input.length === 3) {
    let first = input[0];
    let second = input[1];
    let last = input[2];
    input = first + first + second + second + last + last;
  }
  input = input.toUpperCase(input);
  let first = input[0] + input[1];
  let second = input[2] + input[3];
  let last = input[4] + input[5];
  return parseInt(first, 16) + ', ' + parseInt(second, 16) + ', ' + parseInt(last, 16);
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  media: {
    height: 140,
  },
  mediaHeader: {
    height: 240,
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightBold,
  },
  headingNormal: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: theme.typography.fontWeightRegular,
  },
  // ...testimonialsSection,
  pageHeader: {
    position: 'relative',
    height: '100vh',
    maxHeight: '1600px',
    backgroundPosition: '50%',
    backgroundSize: 'cover',
    margin: '0',
    padding: '0',
    border: '0',
    display: 'flex',
    WebkitBoxAlign: 'center',
    MsFlexAlign: 'center',
    alignItems: 'center',
    '&:before': {
      background: 'rgba(' + hexToRgb('#000') + ', 0.5)',
    },
    '&:after,&:before': {
      position: 'absolute',
      zIndex: '1',
      width: '100%',
      height: '100%',
      display: 'block',
      left: '0',
      top: '0',
      content: "''",
    },
  },
}));

const BootstrapButton = withStyles({
  root: {
    backgroundColor: 'transparent',
    borderColor: 'white',

    '&:hover': {
      backgroundColor: 'rgba(255,255,255,.1)',
      borderColor: 'transparent',
      boxShadow: 'none',
      color: 'white',
    },
    '&:active': {
      boxShadow: 'none',
      backgroundColor: 'gba(255,255,255,.5)',
      borderColor: 'transparent',
    },
    '&:focus': {
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.5)',
    },
  },
})(Button);

const Landing = (props) => {
  // const { classes } = props;
  const { history, classes } = props;
  const expClasses = useStyles();
  // console.log(expClasses)
  // console.log(<Comments />)
  const { communitiesConnected, communitiesReady, communitiesInprogress, statError } = props;

  return (
    <section>
      <ScrollButton history={history} />
      <div className={expClasses.pageHeader} style={{ backgroundImage: `url("${bg12}")` }}>
        <div className={classes.container}>
          <Grid container>
            {/* <Grid item xs={12} sm={12} md={12}>
              <h1 className="text-danger text-center">Сайт знаходиться в режимі розробки...</h1>
            </Grid> */}
            <Grid item xs={12} sm={12} md={6}>
              <h1 className={classes.title}>
                {' '}
                Програмний комплекс <br />
                «Інтегрована інформаційна система «Соціальна громада»
              </h1>
              <h4>Швидке оформлення адміністративних послуг соціального характеру!</h4>
              <BootstrapButton
                size="large"
                //href="/geturl"
                href="https://socgromada.ioc.gov.ua/geturl"
                variant="outlined"
                // color="white"
              >
                ПОДАТИ ЗАЯВУ
              </BootstrapButton>
            </Grid>
            <Grid item xs={12} sm={12} md={6} className={classes.mlAuto}></Grid>
          </Grid>
        </div>
      </div>

      <Definition />

      <div className={classes.container} style={{ paddingTop: '50px' }}>
        <TeachingVideo />
      </div>

      <div className={classes.container} style={{ paddingTop: '50px' }}>
        <Advantages />
      </div>
      <div className={classes.container} style={{ paddingTop: '50px' }}>
        <ServiceList />
      </div>
      {/* <div className={classes.container} style={{ paddingTop: '50px' }}>
        <Importance />
      </div> */}
      <Users />
      <Roles />
      <div className={classes.container} style={{ paddingTop: '50px' }}>
        <Connecting />
      </div>
      <div className={classes.container} style={{ paddingTop: '50px' }}>
        <Spreading
          communitiesConnected={communitiesConnected}
          communitiesReady={communitiesReady}
          communitiesInprogress={communitiesInprogress}
          statError={statError}
        />
      </div>

      <Comments />

      {/* </Container > */}
    </section>
  );
};

export default withRouter(withStyles(headersSection)(Landing));
